import React, { Component } from 'react';

class Point extends Component {
    render () {
        return (
            <div className="point">
                <div className="point_date">
                    <span>
                        <div className="point_date_icon"></div>
                        {this.props.content.dateTime.date}
                    </span>
                    <span>{this.props.content.dateTime.time}</span>
                </div>
                <div className="point_body">
                    <h4>{this.props.content.status}</h4>
                    <span>{this.props.content.location}</span>
                    {this.props.content.notes
                        ?   <div>
                                <h5>Παρατηρήσεις: </h5>
                                <p>{ this.props.content.notes }</p>
                            </div>
                        : ""
                    }
                </div>
            </div>
        );
    }
}

export default Point;